import { gql, TypedDocumentNode } from "@apollo/client";

import { OrganizationPersonalApiKey } from "./types";

type GetOrganizationPersonalApiKeysData = {
  personalApiKeys: OrganizationPersonalApiKey[];
};

export const GET_ORGANIZATION_PERSONAL_API_KEYS: TypedDocumentNode<GetOrganizationPersonalApiKeysData> = gql`
  query GetOrganizationPersonalApiKeys {
    personalApiKeys {
      id
      name
      description
      type
      owner
      createdAt
      expiresAt
      lastUsedAt
      disabled
      disabledAt
      disabledReason
    }
  }
`;
